import React from "react";
import { MaterialReactTable } from "material-react-table";

const CustomPagingTable = ({
  loading,
  columns,
  data,
  rowCount,
  state,
  onPaginationChange,
  pageSizeOptions = [5, 10, 20],
  enableFullScreenToggle = false,
  enableHiding = false,
  enableGlobalFilter = false,
  enableColumnFilters = false,
  enableColumnActions = false,
  enableRowNumbers = false,
  enableSorting = false,
  enableTopToolbar = false,
  enableBottomToolbar = true,
  enablePagination = true,
  renderRowActions,
  manualPagination = true,
  columnVisibility = true,
  noWrap,
}) => {
  return (
    <div className={`table-wrapper ${noWrap ? "nowrap" : "wrap"}`}>
      <MaterialReactTable
        enableStickyHeader
        columns={columns}
        data={data}
        rowCount={rowCount}
        density="compact" // 'comfortable' | 'compact' | 'spacious'
        enableDensityToggle={false}
        enableHiding={enableHiding}
        enablePagination={enablePagination}
        enableFullScreenToggle={enableFullScreenToggle}
        enableColumnFilters={enableColumnFilters}
        enableColumnActions={enableColumnActions}
        enableTopToolbar={enableTopToolbar}
        enableBottomToolbar={enableBottomToolbar}
        enableSorting={enableSorting}
        enableRowNumbers={enableRowNumbers}
        enableGlobalFilter={enableGlobalFilter}
        positionGlobalFilter="left"
        muiSearchTextFieldProps={{
          placeholder: `Search ${data ? data?.length : 0} rows`,
          sx: { minWidth: "300px" },
          variant: "outlined",
        }}
        renderRowActions={renderRowActions}
        onPaginationChange={onPaginationChange}
        manualPagination={manualPagination}
        state={{ ...state, pagination: state.pagination, showProgressBars: loading }}
        muiTablePaginationProps={{
          rowsPerPageOptions: pageSizeOptions,
          pageSize: state.pagination.pageSize,
          showFirstButton: true,
          showLastButton: true,
        }}
        initialState={{
          columnVisibility: columnVisibility,
          showGlobalFilter: enableGlobalFilter,
          pagination: {
            pageSize: state.pagination.pageSize,
            pageIndex: state.pagination.pageIndex,
          },
        }}
      />
    </div>
  );
};

export default CustomPagingTable;
